import { render, staticRenderFns } from "./bulk-edit.vue?vue&type=template&id=5d5345e2"
import script from "./bulk-edit.vue?vue&type=script&lang=js"
export * from "./bulk-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports